<template>
  <div align="center" >
    <img
      opacity="0.6"
      class="spinner-logo img-buton-overlay mt-2"
      :class="clase"
      src="../../../assets/images/login/master_isotipo_VP.svg"
      alt="logo"
    />
  </div>
</template>
<script>
export default {
  name: "overlay-button",
  props: {
    loading: {
      default: true,
      type: Boolean,
    },
    clase: {
      default: "",
      type: String,
    },
  },
  emits: [],
  data() {
    return {};
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss">
.img-buton-overlay {
  margin: auto;
  vertical-align: middle;
  width: 20px;
  height: 20px;
}
</style>